import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { func } from "prop-types";
import * as style from "./styles.module.scss";
import { TextFieldGroup } from "../../../common";
import { DOB } from "../../BasicInfo";
import { postReflexAllenOnboardingForm } from "../../../redux/actions";

const agreementRules = [
  "I agree that the 48 hours weekly limit specified in the Working Time Regulations 1998 – Regulation 4 (1) shall not apply in my case.",
  "I understand that this agreement will apply from the starting date I entered above.",
  "Notwithstanding my agreement to dis-apply this limit, I am fully aware that I have a responsibility not to work hours so long that they may impair my efficiency or expose my colleagues, the public or property to risk.",
  "I understand that Reflexallen may need me to keep a record of my working hours and I will do this as and when required. If requested at any time, I will produce the record to Reflexallen or to any Health and Safety Official.",
  "I agree to give not less than one months’ notice to bring this agreement to an end.",
  "I am aware that I am under no obligation to sign this agreement and that it is illegal for me to be subject to any detriment if I decline to sign.",
];

const RegulationsForm = ({ postForm }) => {
  const [employeeName, setEmployeeName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [startDate, setStartDate] = useState({
    birthDay: "",
    birthMonth: "",
    birthYear: "",
  });
  const isSubmitDisabled =
    employeeName === "" ||
    departmentName === "" ||
    startDate.birthDay === "" ||
    startDate.birthMonth === "" ||
    startDate.birthYear === "";

  const handleDateChange = (fieldName, value) => {
    setStartDate({ ...startDate, [fieldName]: value });
  };

  const handleSubmit = () => {
    postForm({
      online_form: "regulations-form",
      data: {
        employeeName,
        departmentName,
        startDate: {
          day: startDate.birthDay,
          month: startDate.birthMonth,
          year: startDate.birthYear,
        },
      },
    });
  };

  return (
    <div className="w-100 d-flex justify-content-center flex-column align-items-center">
      <div className={style.container}>
        <h2>Working Time Regulation Opt Out Agreement</h2>
        <div className={style.container__form_container}>
          <p className="text-center">
            Please check the information you enter before submitting, as once
            submitted it can not be edited.
          </p>
          <b className="text-center">
            All fields marked with an asterisk* are required.
          </b>
          <div className={style.regulationsForm__form}>
            <div className="form-group mt-1">
              <label htmlFor="employeeName">Name of employee*</label>
              <TextFieldGroup
                inputId="employeeName"
                inputName="employeeName"
                value={employeeName || ""}
                onChange={(e) => setEmployeeName(e.target.value)}
                classes={`register_field`}
                isBold
              />
            </div>
            <div className="form-group mt-1">
              <label htmlFor="departmentName">Department*</label>
              <TextFieldGroup
                inputId="departmentName"
                inputName="departmentName"
                value={departmentName || ""}
                onChange={(e) => setDepartmentName(e.target.value)}
                classes={`register_field`}
                isBold
              />
            </div>
            <div className="form-group">
              <label htmlFor="departmentName">Start date*</label>
              <div
                className={`form-group row justify-content-center d-flex ${style.regulationsForm__date}`}
              >
                <DOB
                  title={""}
                  dayOfBirth={startDate.days}
                  monthOfBirth={startDate.months}
                  yearOfBirth={startDate.year}
                  handleChange={handleDateChange}
                />
              </div>
            </div>
          </div>
          <p className="text-center">
            This agreement is drawn up under the Working Time Regulations
            (Statutory Instrument 1998/1833) Regulation (5) 1 and provides for
            you to enter into an agreement with Reflexallen to opt out of the 48
            hours limit in respect of the total weekly average hours required in
            your case.
          </p>
          <ol className="pl-1">
            {agreementRules.map((rule) => (
              <li key={rule}>
                <p className="pl-1">{rule}</p>
              </li>
            ))}
          </ol>
          <div className="d-flex flex-column flex-md-row-reverse mt-2">
            <Link to="/profile/edit/onboarding">
              <button
                className="btn btn-primary w-100"
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
              >
                Save & submit
              </button>
            </Link>
            <Link
              to="/profile/edit/onboarding"
              className="btn btn-outline-dark mr-md-2 mt-1 mt-md-0"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

RegulationsForm.propTypes = {
  postForm: func,
};

const mapStateToProps = (state) => ({
  reflexAllenOnboarding: state.core.app.reflexAllen,
});

const mapDispatchToProps = {
  postForm: postReflexAllenOnboardingForm,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(RegulationsForm);
